import React from "react";
import styles from "./style.module.scss";

const WorkCard = ({ imageUrl, title, description }) => {
  return (
    <div className={styles.card}>
      <img src={imageUrl} alt="仕事イメージ" className={styles.image} />
      <div className={styles.textArea}>
        <p className={styles.boldText}>{title}</p>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default WorkCard;
